import { Link } from 'react-router-dom'

import logoDark from '../../../assets/logo/logo-dark.svg'
import logoLight from '../../../assets/logo/logo-light.svg'
import { ThemeType } from '../../../types/contexts/AppContext'
import { useApp } from '../../../contexts/AppContext'
import { APP_NAME } from '../../../constants/brand'

type LogoProps = {
  to?: string
  inverted?: boolean
}

const Logo = ({ to = '/', inverted = false }: LogoProps) => {
  const { theme } = useApp()
  const useLightLogo = inverted
    ? theme === ThemeType.LIGHT
    : theme === ThemeType.DARK

  return (
    <Link to={to} className="ph-logo" aria-label={APP_NAME}>
      <img
        src={useLightLogo ? logoLight : logoDark}
        alt=""
        className="ph-logo-image"
      />
    </Link>
  )
}

export default Logo
